import React, { useState } from 'react'

// Maps a broker's `key` to a logo asset in public/brokers/.
// Brokers without an entry (or whose image fails to load) fall back to their emoji icon.
export const BROKER_LOGO: Record<string, string> = {
  dime: '/brokers/dime.webp',
  webull: '/brokers/webull.webp',
  scb_fundclick: '/brokers/scb_fund_click.webp',
  streaming: '/brokers/streaming.webp',
  innovestx: '/brokers/innovestx.webp',
}

interface BrokerLogoProps {
  brokerKey: string
  fallbackIcon?: string
  size?: number
  className?: string
}

const BrokerLogo: React.FC<BrokerLogoProps> = ({ brokerKey, fallbackIcon, size = 24, className = '' }) => {
  const [imgFailed, setImgFailed] = useState(false)
  const logo = BROKER_LOGO[brokerKey]
  const r = Math.round(size * 0.25)

  if (logo && !imgFailed) {
    return (
      <div
        className={`overflow-hidden bg-white flex items-center justify-center shrink-0 ${className}`}
        style={{ width: size, height: size, borderRadius: r }}
      >
        <img
          src={logo}
          alt={brokerKey}
          className="w-full h-full object-contain p-0.5"
          onError={() => setImgFailed(true)}
        />
      </div>
    )
  }

  return (
    <span
      className={`flex items-center justify-center leading-none shrink-0 ${className}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.68) }}
    >
      {fallbackIcon ?? '🏦'}
    </span>
  )
}

export default BrokerLogo
